module.exports = __webpack_public_path__ + "img/tapas.0e6e804b.jpg";